import { render } from "./welcoming-new-joiners-confirmation.vue?vue&type=template&id=ec7d2610&lang=pug"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__